// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c12246b2","627":"857b35da","707":"972dde3f","796":"23f70607"}[chunkId] + ".chunk.js";
};